import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import {
  BrowseCallback,
  BrowseCallbackError,
  BrowseLogin,
  BrowseLogout,
  BrowsePasswordless,
  BrowseResetPassword,
} from './views'
import { setupNewRelic } from './utils/newrelic'

import styles from './App.scss'

export default function App(): JSX.Element {
  useEffect(() => {
    setupNewRelic()
  }, [])

  return (
    <>
      <main className={styles.main}>
        <Switch>
          <Route path="/sso/browse/callback/error" component={BrowseCallbackError} />
          <Route path="/sso/browse/callback" component={BrowseCallback} />
          <Route path="/sso/browse/login" component={BrowseLogin} />
          <Route path="/sso/browse/logout" component={BrowseLogout} />
          <Route path="/sso/browse/passwordless/end" component={BrowsePasswordless} />
          <Route path="/sso/browse/reset-password/end" component={BrowseResetPassword} />
        </Switch>
      </main>
    </>
  )
}
